import { render, staticRenderFns } from "./approval_letters.vue?vue&type=template&id=61af11ba&scoped=true"
import script from "./approval_letters.vue?vue&type=script&lang=js"
export * from "./approval_letters.vue?vue&type=script&lang=js"
import style0 from "./approval_letters.vue?vue&type=style&index=0&id=61af11ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61af11ba",
  null
  
)

export default component.exports